import { locales } from '@americanexpress/conditional-features';
import { getAirSmartFillUrl, getCarSmartFillUrl, getHotelSmartFillUrl } from '../selectors/apiSelectors';
import { formatSmartFillCarData, formatSmartFillFlightData, formatSmartFillHotelData } from '../utils/formatSmartFillDataUtils';

const { EN_GB, EN_US } = locales;

export const CLIENT_ID = '684C957199C3BE6C153A778D1986032B';

export const V2_LXP_APP_ID = {
  [EN_GB]: 'amex-uk',
  [EN_US]: 'amex-us',
};

export const LXP_URL_BY_SEARCH_TYPE = {
  FLIGHT: getAirSmartFillUrl,
  HOTEL: getHotelSmartFillUrl,
  FHR: getHotelSmartFillUrl,
  THC: getHotelSmartFillUrl,
  PACKAGE: getAirSmartFillUrl,
  CAR: getCarSmartFillUrl,
};

export const LXP_RESULTS_BY_SEARCH_TYPE = {
  FLIGHT: formatSmartFillFlightData,
  HOTEL: formatSmartFillHotelData,
  FHR: formatSmartFillHotelData,
  THC: formatSmartFillHotelData,
  PACKAGE: formatSmartFillFlightData,
  CAR: formatSmartFillCarData,
};
